<template>
  <div>
    <CModal
      :title="$t('newEvaluation')"
      color="primary"
      centered
      :closeOnBackdrop="false"
      size="xl"
      :show.sync="$store.state.newEvaluationModal"
      @update:show="changeShowStatus"
    >
      <template #header>
        <h6 class="modal-title">{{$t('newEvaluation')}}</h6>
        <CButtonClose @click="() => {
          $store.commit('setNewEvaluationModal', false)
          resetModal()
        }" class="text-white"/>
      </template>
      <CCard>
        <CCardBody>
          <CForm>
            <CRow>
              <CCol sm="12" md="12">
								<CRow v-show="step == 1">
									<CCol sm="12" md="6">
                  	<h5 class="bg-primary text-white text-center py-2">{{ $t('evaluateData') }} </h5>
										<div role="group" class="form-group form-row">
											<label class="col-form-label col-sm-3"> {{ $t('userToEvaluate') }} </label>
											<div class="col-sm-9">
												<v-select
													:loading="$store.state.loadingEvaluationClientList"
													:placeholder="$t('selectUserToEvaluate')"
													:options="$store.state.evaluationClientList"
													@search="searchUserEv"
													:clearable="false"
													label="nombre"
													required
													
													:filterBy="myFilter"
													:isValid="needValidation ? required:undefined"
													@option:selected="(user) => {
														userSelected(user)
													}"
													v-model="evaluado">
													<template #option="{nombre, apellido, email}">
														<p class="mb-0">{{nombre}} {{apellido}}</p>
														<p class="mb-0"><small>{{email}}</small></p>
														<hr class="my-0"/>
													</template>
													<template #selected-option="{nombre, apellido, email}">
														<p class="mb-0">{{nombre}} {{apellido}} <small>({{email}})</small></p>
													</template>
												</v-select>
												<div>

												</div>
												<small>Busca por el email o nombre del usuario a evaluar</small>
											</div>
											<CBadge
												v-if="newEvaluation.ecrono < 13"
												color="warning"
												aria-multiline
												class="mx-2 px-2 py-1 text-white w-100"
												style="white-space: normal;">
												<CIcon name="cil-bell"/>
												{{$t('ageUnder13')}}
											</CBadge>
											<CButton
												v-if="newEvaluation.ecrono < 13"
												class="mx-2 px-2 py-1 text-white w-100"
												color='primary'
												block
												size="small"
												@click="modifyUserStart">{{$t('ageUnder13Button')}}</CButton>
										</div>
									</CCol>
									<CCol sm="12" md="6">
                  	<h5 class="bg-primary text-white text-center py-2">{{ $t('evaluationType') }}</h5>
										<CButton :color="selectedType == 1 ? 'primary':'secondary'" block
											@click="selectedType = 1">{{$t('bioMethod')}}</CButton>
										<!-- <CButton :color="selectedType == 2 ? 'primary':'secondary'" block
											@click="selectedType = 2">Método Cinta Métrica</CButton> -->
										<CButton :color="selectedType == 4 ? 'primary':'secondary'" block
											@click="selectedType = 4">{{$t('fourPMethod')}}</CButton>
										<CButton :color="selectedType == 3 ? 'primary':'secondary'" block
											@click="selectedType = 3">{{$t('imcMethod')}}</CButton>
									</CCol>
								</CRow>
								<CRow v-show="step == 2">
									<CCol sm="12" md="12">
                  	<h5 class="bg-primary text-white text-center py-2">{{$t('entryData')}}</h5>
									</CCol>
									<CCol sm="12" md="6">
										<CInput
											v-model="newEvaluation.estatura"
											:label="$t('height')"
											type="number"
											:placeholder="$t('enterHeight')"
											horizontal
											:isValid="needValidation ? required:undefined"
										/>
										<CInput
											v-model="newEvaluation.peso"
											:label="$t('weight')"
											type="number"
											:placeholder="$t('enterWeight')"
											horizontal
											:isValid="needValidation ? required:undefined"
										/>
										<div role="group" class="form-group form-row">
											<label class="col-form-label col-sm-3"> {{$t('smoker')}} </label>
											<div class="col-sm-9">
												<v-select
													:placeholder="$t('smoker')"
													:options="[{label: $t('yes'), value: 'Si'}, {label: $t('no'), value: 'No'}]"
                      		:reduce="data => data.value"
													:clearable="false"
													required
													:isValid="needValidation ? required:undefined"
													v-model="newEvaluation.fuma"></v-select>
											</div>
										</div>
										<div role="group" class="form-group form-row">
											<label class="col-form-label col-sm-3"> {{$t('drinkAlcohol')}} </label>
											<div class="col-sm-9">
												<v-select
													:placeholder="$t('drinkAlcohol')"
													:options="[{label: $t('yes'), value: 'Si'}, {label: $t('no'), value: 'No'}]"
                      		:reduce="data => data.value"
													:clearable="false"
													required
													:isValid="needValidation ? required:undefined"
													v-model="newEvaluation.alcohol"></v-select>
											</div>
										</div>
										<div role="group" class="form-group form-row">
											<label class="col-form-label col-sm-6"> {{$t('doesExercise')}} </label>
											<div class="col-sm-6">
												<v-select
													:placeholder="$t('doesExercise')"
													:options="[{label: $t('yes'), value: 'Si'}, {label: $t('no'), value: 'No'}]"
                      		:reduce="data => data.value"
													:clearable="false"
													required
													:isValid="needValidation ? required:undefined"
													v-model="newEvaluation.ejercita"></v-select>
											</div>
										</div>
										<div role="group" class="form-group form-row">
											<label class="col-form-label col-sm-6"> {{newEvaluation.ejercita == 'No' ? $t('noSinceTrainingQuestion'):$t('sinceTrainingQuestion')}} </label>
											<div class="col-sm-6">
												<v-select
													:placeholder="newEvaluation.ejercita == 'No' ? $t('noSinceTrainingQuestion'):$t('sinceTrainingQuestion')"
													:options="haceEntreno"
													:clearable="false"
													required
                      		:reduce="data => data.value"
													:isValid="needValidation ? required:undefined"
													v-model="newEvaluation.hace"></v-select>
											</div>
										</div>
										<div role="group" class="form-group form-row" v-if="newEvaluation.ejercita == 'Si'">
											<label class="col-form-label col-sm-6"> {{$t('trainingFrequencyQuestion')}} </label>
											<div class="col-sm-6">
												<v-select
													:placeholder="$t('trainingFrequencyQuestion')"
													:options="frecEntreno"
													:clearable="false"
													required
                      		:reduce="data => data.value"
													:isValid="needValidation ? required:undefined"
													v-model="newEvaluation.frecentrena"></v-select>
											</div>
										</div>
									</CCol>
									<CCol sm="12" md="6">
										<CInput
											v-model="newEvaluation.pcintura"
											:label="$t('waistPerimeter')"
											type="number"
											:placeholder="$t('enterWaistPerimeter')"
											:horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
											:isValid="needValidation ? required:undefined"
										/>
										<CInput
											v-model="newEvaluation.pcadera"
											:label="$t('hipPerimeter')"
											type="number"
											:placeholder="$t('enterHipPerimeter')"
											:horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
											:isValid="needValidation ? required:undefined"
										/>
										<CInput
											v-model="newEvaluation.pbrazo"
											:label="$t('armPerimeter')"
											type="number"
											:placeholder="$t('enterArmPerimeter')"
											:horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
											:isValid="needValidation ? required:undefined"
										/>
										<CInput
											v-model="newEvaluation.ppierna"
											:label="$t('legPerimeter')"
											type="number"
											:placeholder="$t('enterLegPerimeter')"
											:horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
											:isValid="needValidation ? required:undefined"
										/>
										<CInput
											v-if="selectedType == 1"
											v-model="newEvaluation.pgrasa"
											:label="$t('fatPercent')"
											type="number"
											:placeholder="$t('enterFatPercent')"
											:horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
											:isValid="needValidation ? required:undefined"
										/>
										<CInput
											v-if="selectedType == 3"
											v-model="newEvaluation.cuello"
											:label="$t('neckPerimeter')"
											type="number"
											:placeholder="$t('enterArmPerimeter')"
											:horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
											:isValid="needValidation ? required:undefined"
										/>
										<CInput
											v-model="newEvaluation.presion_s"
											:label="$t('sistolic')"
											type="number"
											:placeholder="$t('enterSistolic')"
											:horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
											:isValid="needValidation ? required:undefined"
										/>
										<CInput
											v-model="newEvaluation.presion_d"
											:label="$t('diastolic')"
											type="number"
											:placeholder="$t('enterDiastolic')"
											:horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
											:isValid="needValidation ? required:undefined"
										/>
										<CInput
											v-if="selectedType == 4"
											v-model="newEvaluation.triceps"
											:label="$t('pTriceps')"
											type="number"
											:placeholder="$t('enterPTriceps')"
											:horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
											:isValid="needValidation ? required:undefined"
										/>
										<CInput
											v-if="selectedType == 4"
											v-model="newEvaluation.subescapular"
											:label="$t('pSubescapular')"
											type="number"
											:placeholder="$t('enterPSubescapular')"
											:horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
											:isValid="needValidation ? required:undefined"
										/>
										<CInput
											v-if="selectedType == 4"
											v-model="newEvaluation.abdominal"
											:label="$t('pAbdominal')"
											type="number"
											:placeholder="$t('enterPAbdominal')"
											:horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
											:isValid="needValidation ? required:undefined"
										/>
										<CInput
											v-if="selectedType == 4"
											v-model="newEvaluation.cuadriceps"
											:label="$t('pCuadriceps')"
											type="number"
											:placeholder="$t('enterPCuadriceps')"
											:horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
											:isValid="needValidation ? required:undefined"
										/>
									</CCol>
								</CRow>
              </CCol>
            </CRow>
						<CRow v-show="step == 2">
							<CCol sm="12" md="12">
								<h5 class="bg-primary text-white text-center py-2">{{$t('rockportTest')}}</h5>
							</CCol>
							<CCol sm="12" md="6">
								<div class="d-flex justify-content-between align-items-center">
									<CLabel>{{$t('rockportMileTime')}}</CLabel>
									<CInput
										v-model="newEvaluation.rockport.minutes"
										type="number"
										horizontal
										:placeholder="$t('minutes')"
									>
									</CInput>
									<CInput
										v-model="newEvaluation.rockport.seconds"
										type="number"
										horizontal
										:placeholder="$t('seconds')"
									>
									</CInput>
								</div>
							</CCol>
							<CCol sm="12" md="6">
								<CInput
									v-model="newEvaluation.rockport.bpm"
									:label="$t('BPM')"
									type="number"
									horizontal
									:placeholder="$t('BPM')"
								>
								</CInput>
							</CCol>
							<CCol sm="12" md="12">
								<h5 class="bg-primary text-white text-center py-2">{{$t('clinicalData')}}</h5>
							</CCol>
							<CCol sm="12" md="6">
								<CInput
									v-model="newEvaluation.clinical_data.temperatura"
									:label="$t('temperature')"
									type="number"
									horizontal
									:placeholder="$t('temperature') + ' ºC'"
									:isValid="needValidation ? required:undefined"
								>
								<div slot="description">
									<p class="mb-0 text-right text-danger" v-if="newEvaluation.clinical_data.temperatura >= 37.9">
										<CIcon name="cil-warning" class="mr-2"/> 
										<small>{{$t('feverCaution')}}</small>
									</p>
								</div>
								</CInput>
							</CCol>
							<CCol sm="12" md="6">
                <CRow form class="form-group">
                  <CCol sm="6">
                    {{$t('hasDificulToBreath')}}
                  </CCol>
                  <CInputRadioGroup
                    class="col-sm-6"
                    :options="[{value: true, label: $t('yes')},{value: false, label: $t('no')}]"
										:value="newEvaluation.clinical_data.dif_respirar"
										:checked.sync="newEvaluation.clinical_data.dif_respirar"
                    inline
                  />
                </CRow>
							</CCol>
							<CCol sm="12" md="6">
								<div class="py-3">
									<div class="d-flex justify-content-between px-2 py-1 bg-dark">
										<p class="mb-0 text-white px-2">{{$t('hasECNTtitle')}}</p>
										<p class="mb-0 text-white text-right px-2">{{$t('markIntreatment')}}</p>
									</div>
									<div class="d-flex justify-content-between px-2 py-1"
										:class="optionIndex%2 != 0 ? 'bg-secondary':''"
										v-for="(option, optionIndex) in newEvaluation.clinical_data.ecnt" :key="optionIndex">
										<div class="d-flex">
											<CInputCheckbox
												:label="option.showInput ? '':$t(option.name)"
												:value="option.value"
												:name="optionIndex"
												:checked.sync="option.value"
											/>
											<CInput
												v-if="option.showInput"
												v-model="option.name"
												:placeholder="$t('otherDisease')"
												class="mb-0"
											/>
										</div>
										<CInputCheckbox
											:disabled="!option.value"
											:value="option.tratamiento"
											:name="optionIndex"
											:checked.sync="option.tratamiento"
										/>
									</div>
								</div>
							</CCol>
							<CCol sm="12" md="6">
								<div class="py-3">
									<div class="d-flex justify-content-between px-2 py-1 bg-dark">
										<p class="mb-0 text-white px-2">{{$t('hasAutoinmuneTitle')}}</p>
										<p class="mb-0 text-white text-right px-2">{{$t('markIntreatment')}}</p>
									</div>
									<div class="d-flex justify-content-between px-2 py-1"
										:class="optionIndex%2 != 0 ? 'bg-secondary':''"
										v-for="(option, optionIndex) in newEvaluation.clinical_data.autoinmune" :key="optionIndex">
										<div class="d-flex">
											<CInputCheckbox
												:label="option.showInput ? '':$t(option.name)"
												:value="option.value"
												:name="optionIndex"
												:checked.sync="option.value"
											/>
											<CInput
												v-if="option.showInput"
												v-model="option.name"
												:placeholder="$t('otherDisease')"
												class="mb-0"
											/>
										</div>
										<CInputCheckbox
											:disabled="!option.value"
											:value="option.tratamiento"
											:name="optionIndex"
											:checked.sync="option.tratamiento"
										/>
									</div>
								</div>
							</CCol>
							<CCol sm="12" md="12">
								<h5 class="bg-primary text-white text-center py-2">{{$t('examsTitle')}}</h5>
							</CCol>
							<CCol sm="12" md="12">
                <CRow class="bg-dark no-gutters">
                  <CCol sm="12" md="6">
											<p class="mb-0 text-white px-2">{{$t('exam')}}</p>
									</CCol>
                  <CCol sm="12" md="2">
											<p class="mb-0 text-white px-2">{{$t('value')}}</p>
									</CCol>
                  <CCol sm="12" md="2">
											<p class="mb-0 text-white px-2">{{$t('measureUnit')}}</p>
									</CCol>
                  <CCol sm="12" md="2">
											<p class="mb-0 text-white px-2">{{$t('limitValue')}}</p>
									</CCol>
								</CRow>
                <CRow class="no-gutters px-1 py-1" align-vertical="center" v-for="(option, optionIndex) in newEvaluation.clinical_data.exams" :key="optionIndex"
										:class="optionIndex%2 != 0 ? 'bg-secondary':''">
                  <CCol sm="12" md="6">
										<CInputCheckbox
											:label="option.name"
											:value="option.status"
											:name="optionIndex"
											:checked.sync="option.status"
										/>
									</CCol>
                  <CCol sm="12" md="2">
										<CInput
											v-model="option.value"
											:placeholder="$t('value')"
											class="mb-0 mx-2"
											size="sm"
											:disabled="!option.status"
										/>
									</CCol>
                  <CCol sm="12" md="2">
											<p class="mb-0 px-2">{{option.unit}}</p>
									</CCol>
                  <CCol sm="12" md="2">
											<div class="mb-0 px-2" v-html="option.limit"></div>
									</CCol>
								</CRow>
							</CCol>
						</CRow>
          </CForm>
        </CCardBody>
      </CCard>
      <div slot="footer" class="d-flex align-items-center justify-end">
        <CBadge v-if="showRequiredAlert" color="warning" class="mx-2 px-2 py-1 text-white"><CIcon name="cil-bell"/> {{$t('fieldRequiredEv')}}</CBadge>
				<CButton v-if="step > 1" color="secondary" @click="step--" :disabled="loading" class="mr-3"><CIcon name="cil-chevron-left"/> {{$t('back')}}</CButton>
        <CButton v-if="step == 2" type="submit" color="primary" @click="sendForm" :disabled="loading"><CIcon name="cil-check-circle"/> {{$t('sendEvaluation')}}</CButton>
				<CButton v-else color="success" @click="step = 2" :disabled="loading || stopNextStep">{{$t('next')}}</CButton>
      </div>
    </CModal>
  </div>
</template>

<script>
import {required, email} from '@/helpers/validators'
import moment from 'moment'
import _debounce from 'lodash/debounce'
import {createEvaluation} from '@/helpers/api/evaluations'

export default {
  name: 'NewEvaluation',
  data () {
    return {
			myFilter: (option, label, search) => {
				return true
				if(search.length > 3){
					const name = option.nombre + ' ' + option.apellido
					return name.toLowerCase().includes(search.toLowerCase()) || option.email.toLowerCase().includes(search.toLowerCase())
				}
			},
			stopNextStep: false,
			selectedUser: null,
			needUserReload: false,
			selectedType: 1,
			step: 1,
      needValidation: false,
      showRequiredAlert: false,
			showRockport: false,
      loading: false,
      haceEntreno: [
				{label: this.$i18n.t('rangeEntrenoA'), value: 1},
				{label: this.$i18n.t('rangeEntrenoB'), value: 2},
				{label: this.$i18n.t('rangeEntrenoC'), value: 3},
				{label: this.$i18n.t('rangeEntrenoD'), value: 4},
				{label: this.$i18n.t('rangeEntrenoE'), value: 5},
				{label: this.$i18n.t('rangeEntrenoF'), value: 6},
			],
      frecEntreno: [
				{label: '2 ' + this.$i18n.t('timesAWeek'), value: 2},
				{label: '3 ' + this.$i18n.t('timesAWeek'), value: 3},
				{label: '4 ' + this.$i18n.t('timesAWeek'), value: 4},
				{label: '5 ' + this.$i18n.t('timesAWeek'), value: 5},
				{label: '6 ' + this.$i18n.t('timesAWeek'), value: 6},
				{label: '7 ' + this.$i18n.t('timesAWeek'), value: 7},
			],
			options: ['Test', 'Test 1'],
			evaluado: null,
      newEvaluation: {
				id_evaluado: null,
				peso: null,
				estatura: null,
				presion_d: null,
				presion_s: null,
				pcintura: null,
				pcadera: null,
				pbrazo: null,
				ppierna: null,
				pgrasa: null,
				cuello: null,
				fuma: 'No',
				alcohol: 'No',
				ejercita: 'No',
				hace: 1,
				frecentrena: null,
				triceps: null,
				subescapular: null,
				abdominal: null,
				cuadriceps: null,
				rockport: {
					minutes: null,
					seconds: null,
					bpm: null
				},
				clinical_data: {
					temperatura: '',
					dif_respirar: false,
					ecnt: [
						{name: 'Hipertensión',value: false,tratamiento: false},
						{name: 'Hipercolesteremia',value: false,tratamiento: false},
						{name: 'Diabetes',value: false,tratamiento: false},
						{name: 'Obesidad',value: false,tratamiento: false},
						{name: 'Hígado Graso',value: false,tratamiento: false},
						{value: false,name: '',showInput: true,tratamiento: false},
					],
					autoinmune: [
						{name: 'Lupus',value: false,tratamiento: false},
						{name: 'Celíaca',value: false,tratamiento: false},
						{name: 'Cáncer',value: false,tratamiento: false},
						{name: 'VIH',value: false,tratamiento: false},
						{name: 'Artritis',value: false,tratamiento: false},
						{value: false,name: '',showInput: true,tratamiento: false},
					],
					exams: [
						{name: 'Proteína C reactiva (PCR)', type: 2, unit: '', status: false, limit: '', value: ''},
						{name: 'Concentración de glucosa en ayunas', type: 2, unit: '(mmol/L) (FPG)', status: false, limit: '> 5.5', value: ''},
						{name: 'Triglicéridos en ayunas', type: 2, unit: '(mmol/L)', status: false, limit: '1.0 a 1.5', value: ''},
						{name: 'La concentración de colesterol', type: 2, unit: 'HDL (mmol/L)', status: false, limit: '1.4', value: ''},
						{name: 'En ayuno concentración de insulina', type: 2, unit: '(mUI/L)', status: false, limit: '2.0 a 10.0', value: ''},
						{name: 'Hemoglobina Glicolisada, Glucohemoglobina, HemoglobinaHbA1c, HemoglobinaA1C', type: 2, unit: '', status: false, limit: '5.5', value: ''},
						{name: 'Resistencia a la Insulina HOMA', type: 2, unit: '', status: false, limit: '1.96 a 3.0', value: ''},
						{name: 'Vitamina D', type: 2, unit: 'ng/ml', status: false, limit: '20 - 50', value: ''},
						{name: 'Enzimas hepáticas GGT, Actividad gamma-glutamil transferasa (U/L)', type: 2, unit: '(U/L)', status: false, limit: '45', value: ''},
						{name: 'Colesterol Total', type: 2, unit: 'mg/dL', status: false, limit: '<small>< 19 años: <b>< 170</b> <br/>> 20 años: <b>125 a 200</b></small>', value: ''},
						{name: 'No-HDL', type: 2, unit: 'mg/dL', status: false, limit: '<small>< 19 años: <b>> 120</b> <br/>> 20 años: <b>> 130</b></small>', value: ''},
						{name: 'LDL', type: 2, unit: 'mg/dL', status: false, limit: '<small><b>> 100</b></small>', value: ''},
						{name: 'HDL', type: 2, unit: 'mg/dL', status: false, limit: '<small>< 19 años: <b>< 45</b> <br/>> 20 años varón: <b>< 0 = 40</b><br/>> 20 años dama: <b>< 0 = 50</b></small>', value: ''},
					]
				}
      }
    }
  },
  watch: {
    '$store.state.userData': {
      immediate: true,
      handler (userData) {
        if(userData && !this.$store.state.clientList){
          this.getUsers()
        }
      }
    },
		'$store.state.newEvaluationModal': {
      immediate: true,
      handler (newEvaluationModal) {
				if(this.$store.state.newEvaluationModal && this.needUserReload){
					this.getUsers()
				}
      }
    },
  },
  mounted(){
    this.getUsers()
  },
  methods: {
    required, email,
		searchUserEv: _debounce(function(value){
			this.$store.dispatch('getEvaluationUsersList', {type: 2, search: value})
		}, 800),
		modifyUserStart(){
			if(this.selectedUser){
				this.selectedUser.pais = this.selectedUser.country.country.name
				this.$store.commit('setEditUserModal', {status: true, userData: this.selectedUser})
				this.$store.commit('setNewEvaluationModal', false)
				this.needUserReload = true
				this.resetModal()
			}
		},
    getUsers(){
      this.$store.dispatch('getEvaluationUsersList', {type: 2})
    },
    setDate(type){
      let date = new Date()
      if(type == 1){
        date.setFullYear( date.getFullYear() - 12 )
      }
      else{
        date.setFullYear( date.getFullYear() - 6 )
      }
      return date.toISOString().split("T")[0]
    },
    changeShowStatus(status){
      this.resetModal()
    },
    resetModal(){
			this.selectedType = 1
			this.step = 1
			this.evaluado = null
      this.needValidation = false
      this.showRequiredAlert = false
      this.loading = false
			this.showRockport = false
      this.newEvaluation = {
				id_evaluado: null,
				peso: null,
				estatura: null,
				presion_d: null,
				presion_s: null,
				pcintura: null,
				pcadera: null,
				pbrazo: null,
				ppierna: null,
				pgrasa: null,
				cuello: null,
				fuma: 'No',
				alcohol: 'No',
				ejercita: 'No',
				hace: 1,
				frecentrena: null,
				triceps: null,
				subescapular: null,
				abdominal: null,
				cuadriceps: null,
				rockport: {
					minutes: null,
					seconds: null,
					bpm: null
				},
				clinical_data: {
					temperatura: '',
					dif_respirar: false,
					ecnt: [
						{name: 'Hipertensión',value: false,tratamiento: false},
						{name: 'Hipercolesteremia',value: false,tratamiento: false},
						{name: 'Diabetes',value: false,tratamiento: false},
						{name: 'Obesidad',value: false,tratamiento: false},
						{name: 'Hígado Graso',value: false,tratamiento: false},
						{value: false,name: '',showInput: true,tratamiento: false},
					],
					autoinmune: [
						{name: 'Lupus',value: false,tratamiento: false},
						{name: 'Celíaca',value: false,tratamiento: false},
						{name: 'Cáncer',value: false,tratamiento: false},
						{name: 'VIH',value: false,tratamiento: false},
						{name: 'Artritis',value: false,tratamiento: false},
						{value: false,name: '',showInput: true,tratamiento: false},
					],
					exams: [
						{name: 'Proteína C reactiva (PCR)', type: 2, unit: '', status: false, limit: '', value: ''},
						{name: 'Concentración de glucosa en ayunas', type: 2, unit: '(mmol/L) (FPG)', status: false, limit: '> 5.5', value: ''},
						{name: 'Triglicéridos en ayunas', type: 2, unit: '(mmol/L)', status: false, limit: '1.0 a 1.5', value: ''},
						{name: 'La concentración de colesterol', type: 2, unit: 'HDL (mmol/L)', status: false, limit: '1.4', value: ''},
						{name: 'En ayuno concentración de insulina', type: 2, unit: '(mUI/L)', status: false, limit: '2.0 a 10.0', value: ''},
						{name: 'Hemoglobina Glicolisada, Glucohemoglobina, HemoglobinaHbA1c, HemoglobinaA1C', type: 2, unit: '', status: false, limit: '5.5', value: ''},
						{name: 'Resistencia a la Insulina HOMA', type: 2, unit: '', status: false, limit: '1.96 a 3.0', value: ''},
						{name: 'Vitamina D', type: 2, unit: 'ng/ml', status: false, limit: '20 - 50', value: ''},
						{name: 'Enzimas hepáticas GGT, Actividad gamma-glutamil transferasa (U/L)', type: 2, unit: '(U/L)', status: false, limit: '45', value: ''},
					]
				}
      }
			this.$store.commit('setStates', [])
			this.$store.commit('setComunas', [])
    },
		userSelected(user){
			console.log(user)
			this.selectedUser = user
			this.newEvaluation.id_evaluado = user.id_usuario
			this.newEvaluation.sexo = user.sexo
			this.newEvaluation.ecrono = moment().diff(moment(user.nacimiento, 'YYYY-MM-DD'), 'years')
			if(
				this.newEvaluation.ecrono < 13 ||
				this.newEvaluation.sexo == '' ||
				!this.newEvaluation.sexo ||
				!this.newEvaluation.id_evaluado
			){
				this.stopNextStep = true
				if(this.newEvaluation.ecrono < 13){
					this.$store.commit('addToast', {
						color: 'warning',
						header: 'Error',
						message: 'La edad del evaluado es menor a 13, favor verificar solicite al usuario actualizar su información.'
					})
				}
			}
			else{
				this.stopNextStep = false
			}
		},
		validateRockport(rockport) {
			const { minutes, seconds, bpm } = rockport;

			// Verificar si todos los valores son nulos o indefinidos
			const allNull = [minutes, seconds, bpm].every(value => value === null || value === undefined);

			// Verificar si todos los valores están definidos
			const allDefined = [minutes, seconds, bpm].every(value => value !== null && value !== undefined);

			return allNull || allDefined;
		},
    isValidForm(){
      this.needValidation = true
			if(!this.validateRockport(this.newEvaluation.rockport)){
				this.$store.commit('addToast', {
					color: 'warning',
					header: 'Error',
					message: this.$i18n.t('rockportFieldsError')
				})
				return false
			}
      return Object.keys(this.newEvaluation).every((key) => {
				// if(key == 'presion_s' || key == 'presion_d'){
				// 	return true
				// }
				console.log(key)
				if(this.selectedType == 1 && (key == 'triceps' || key == 'subescapular' || key == 'abdominal'  || key ==  'cuadriceps'  || key ==  'cuello')){
					return true
				}
				if(this.selectedType == 3 && (key == 'pgrasa'  || key == 'triceps' || key == 'subescapular' || key == 'abdominal'  || key ==  'cuadriceps')){
					return true
				}
				if(this.selectedType == 4 && (key == 'pgrasa'  || key ==  'cuello')){
					return true
				}
				if(key == 'frecentrena'){
					return this.newEvaluation.ejercita == 'No' || !!this.newEvaluation[key]
				}
				if(key == 'clinical_data'){
					return !!this.newEvaluation.clinical_data.temperatura
				}
        return !!this.newEvaluation[key]
      })
    },
    async sendForm(){
			console.log(this.newEvaluation)
      if(this.isValidForm() ){
        this.loading = true

				this.newEvaluation.id_evaluador = this.$store.state.userData.id_usuario
				this.newEvaluation.evaluation_type = this.selectedType
				const evaluation = await createEvaluation(this.newEvaluation)
        this.loading = false
				if(evaluation.status == 200 && evaluation.message){
					this.$store.dispatch('getEvaluationList')
					this.$store.commit('setNewEvaluationModal', false)
					this.$router.push({ name: 'Evaluation', params: { evaluationID: evaluation.evaluacion.id } })
					this.resetModal()

					this.$store.commit('addToast', {
						color: 'success',
						header: 'Evaluación Creada',
						message: 'Se ha creado correctamente la evaluación'
					})
				}
				else if(evaluation.status == 422){
					if(evaluation && evaluation.data){
						Object.values(evaluation.data.error.message).forEach((value) => {
							this.$store.commit('addToast', {
								color: 'warning',
								header: 'Error',
								message: value[0]
							})
						});
					}
				}
      }
      else{
        this.showRequiredAlert = true
      }
    }
  }
}
</script>